import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Button, Col, notification, Popconfirm, Row, Tag } from 'antd';
import { isSharedIdentificationFeatureEnabled } from 'constant';
import { useDeleteArticleRelationGroupMutation } from 'services';

import { isSharedIdentification } from '../article-group-modal/share-identification';
import { stripGroupPrefix } from '../strip-group-prefix';

const sharedIdentificationColumns = [
  {
    title: 'Madde',
    dataIndex: 'memberCount',
    key: 'memberCount',
    width: 90,
  },
  {
    title: 'Ana Madde',
    key: 'mainMember',
    render: (_, record) => {
      const title = record.mainMember?.articleOffer?.title;
      return title ? stripGroupPrefix(title, record.name) : '—';
    },
  },
  {
    title: 'Kimlik Kartı',
    key: 'identificationStatus',
    width: 130,
    render: (_, record) => (isSharedIdentification(record) ? <Tag color="blue">Ortak</Tag> : <Tag>Ayrı</Tag>),
  },
];

/**
 * @param {Object} params
 * @param {Function} [params.onEdit] - Düzenle butonuna tıklandığında çağrılacak callback. Parametre olarak record alır.
 */
function useColumn({ onEdit } = {}) {
  const [deleteArticleRelationGroup] = useDeleteArticleRelationGroupMutation();

  const handleDelete = async (id) => {
    const { error } = await deleteArticleRelationGroup({ id });
    if (error) {
      return notification.error({
        message: 'Grup Silme Hatası',
        description: error.data?.message ?? 'Bir hata oluştu.',
      });
    }

    notification.success({
      message: 'Grup Başarıyla Silindi',
    });
  };

  const columns = [
    {
      title: 'Grup Adı',
      dataIndex: 'name',
      key: 'name',
    },
    ...(isSharedIdentificationFeatureEnabled ? sharedIdentificationColumns : []),
    {
      title: 'İşlemler',
      key: 'actions',
      width: 120,
      render: (_, record) => (
        <Row>
          <Col>
            <Button
              type="text"
              icon={<EditOutlined />}
              onClick={() => onEdit?.(record)}
            />
          </Col>
          <Col>
            <Popconfirm
              title="Bu grubu silmek istediğinize emin misiniz?"
              okText="Evet"
              cancelText="Hayır"
              onConfirm={() => handleDelete(record.id)}
            >
              <Button
                type="text"
                icon={<DeleteOutlined />}
              />
            </Popconfirm>
          </Col>
        </Row>
      ),
    },
  ];

  return columns;
}

export default useColumn;
